export default {
	async login({ commit, dispatch }, user) {
		let state = 200;
		await this.$auth
			.loginWith('password_grant', {
				data: {
					email: user.email,
					password: user.password,
				},
			})
			.then((res) => {
				state = 200;
			})
			.catch((error) => {
				console.error(error);
				if (error.message.includes('400')) {
					state = 400;
				} else if (error.message.includes('401')) {
					state = 401;
				} else if (error.message.includes('404')) {
					state = 404;
				} else if (error.message.includes('500')) {
					state = 500;
				} else {
					state = 500;
				}
			});
		return state;
	},
	async changePassword({ commit }, passwords) {
		let result = null;
		await this.$axios
			.$post(this.$api.common.changePassword, passwords)
			.then((response) => {
				this.$alert.success('パスワードは正常に変更されました');
				result = 200;
			})
			.catch((error) => {
				switch (error.response.status) {
					case 401:
						commit('app/setExpired', true, { root: true });
						break;
					case 422:
						result = error.response.data || null;
						break;
					case 500:
					default:
						this.$alert.error('サーバエラーが発生しました');
				}
			});
		return result;
	},
	async routeOwnDashboard() {
		await this.$auth.fetchUser().catch((error) => {
			this.$auth.logout();
		});
		switch (this.$auth.user && this.$auth.user.role) {
			case this.$role.user:
				if (process.browser) {
					window.location.href = this.$page.user.dashboard;
				} else {
					this.$router.push(this.$page.user.dashboard);
				}
				break;
			case this.$role.tenantAdmin:
				if (process.browser) {
					window.location.href = this.$page.tenantAdmin.dashboard;
				} else {
					this.$router.push(this.$page.tenantAdmin.dashboard);
				}
				break;
			case this.$role.systemAdmin:
				if (process.browser) {
					window.location.href = this.$page.systemAdmin.dashboard;
				} else {
					this.$router.push(this.$page.systemAdmin.dashboard);
				}
				break;
			default:
				if (process.browser) {
					window.location.href = this.$page.login;
				} else {
					this.$router.push(this.$page.login);
				}
				break;
		}
	},
	async getUserData({ commit }) {
		return await this.$axios.$get(this.$api.common.userData).catch((error) => {
			switch (error.response.status) {
				case 400:
				case 401:
					commit('app/setExpired', true, { root: true });
					break;
				default:
					this.$alert.error('サーバエラーが発生しました');
			}
			throw error;
		});
	},
	async fetchTopPageData() {
		let result = null;
		await this.$axios
			.$get(this.$api.common.topPageData)
			.then((response) => {
				result = response;
			})
			.catch((error) => {
				result = { information: {} };
				this.$alert.error('サーバエラーが発生しました');
			});
		return result;
	},

	async fetchTopPageFAQ() {
		let result = null;
		await this.$axios
			.$get(this.$api.common.fetchTopPageFAQ)
			.then((response) => {
				result = response;
			})
			.catch((error) => {
				result = { faq: null };
				this.$alert.error('サーバエラーが発生しました');
			});
		return result;
	},
};
